import type { Client } from '../services/api';
import type { ComboBoxOption } from '../ds/ComboBox';

/** Etykieta zarządcy na listach wyboru: „skrót — pełna nazwa" (skrót z migr. 055), bez skrótu — sama nazwa. */
export const clientLabel = (c: Pick<Client, 'name' | 'shortName'>): string => (c.shortName ? `${c.shortName} — ${c.name}` : c.name);

/**
 * B3 (Bronek 21.10): opcje pola „Zarządca" z podpowiedziami (ds/ComboBox) — alfabetycznie po etykiecie, wyszukiwane
 * po pełnej nazwie i skrócie (fragment, bez wielkości liter i polskich znaków). Jedno źródło dla filtra listy budynków,
 * „Przypisz zarządcę (N)" i okien planowania (PlanClientFields).
 */
export function clientComboOptions(clients: Client[]): ComboBoxOption[] {
  return [...clients]
    .sort((a, b) => clientLabel(a).localeCompare(clientLabel(b), 'pl'))
    .map((c) => ({ value: c.id, label: clientLabel(c), keywords: [c.shortName, c.name] }));
}
